import { Component, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { IUploadingStatus } from 'src/app/services/file.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LoaderComponent } from '../../loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface UploadDialogOptions {
    mode: 'uploading' | 'downloading' | 'archiving';
    status: IUploadingStatus | null;
    title: string,
    text: string;
}


@Component({
    selector: 'app-uploading-dialog',
    templateUrl: './uploading-dialog.component.html',
    styleUrls: ['./uploading-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, LoaderComponent, TranslatePipe]
})
export class UploadingDialogComponent implements OnDestroy {
    dialogRef = inject<MatDialogRef<UploadingDialogComponent>>(MatDialogRef);
    data = inject<UploadDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: UploadDialogOptions = {
        mode: 'uploading',
        status: null,
        title: 'UPLOADING',
        text: 'UPLOADING_IN_PROGRESS'
    };

    public ctx: UploadDialogOptions;

    protected sub: Subscription = new Subscription();

    constructor() {
        this.ctx = this.data;
        this.dialogRef.disableClose = true;
        if (!this.ctx.status) {
            this.dialogRef.close();
        }
        this.sub.add(this.ctx.status?.uploading.subscribe((value: boolean) => {
            if (!value)
                this.dialogRef.close();
        }));
        this.ctx = {
            ...this.ctx,
            title: this.ctx.mode === 'downloading' ? 'DOWNLOADING' : ( this.ctx.mode === 'archiving' ? 'ARCHIVING' : 'UPLOADING'),
            text: this.ctx.mode === 'downloading' ? 'DOWNLOADING_IN_PROGRESS' : ( this.ctx.mode === 'archiving' ? 'ARCHIVING_IN_PROGRESS' : 'UPLOADING_IN_PROGRESS'),
        };
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
